import { publicApiClient } from './publicApiClient';

export interface PartnerAccount { id: number; fullName: string; email: string; organizationName: string; partnerType: string | null }

export interface PartnerProject {
  id: number; project_reference: string; project_name: string; description: string | null;
  status: string; start_date: string; end_date: string; linked_at: string;
}
export interface PartnerDocument {
  id: number; document_type: string; original_filename: string; mime_type: string; size_bytes: number;
  uploaded_by_name: string | null; uploaded_by_partner_organization: string | null; created_at: string;
}

export const partnerPortalApi = {
  register: (input: { email: string; password: string; fullName: string; organizationName: string; phone?: string }) =>
    publicApiClient.post<{ data: { message: string } }>('/api/partner/auth/register', input),
  verifyEmail: (token: string) => publicApiClient.get<{ data: { message: string } }>(`/api/partner/auth/verify-email?token=${encodeURIComponent(token)}`),
  login: (input: { email: string; password: string }) => publicApiClient.post<{ data: PartnerAccount }>('/api/partner/auth/login', input),
  logout: () => publicApiClient.post<{ data: { message: string } }>('/api/partner/auth/logout'),
  me: () => publicApiClient.get<{ data: PartnerAccount | null }>('/api/partner/auth/me'),
  forgotPassword: (email: string) => publicApiClient.post<{ data: { message: string } }>('/api/partner/auth/forgot-password', { email }),
  resetPassword: (token: string, newPassword: string) => publicApiClient.post<{ data: { message: string } }>('/api/partner/auth/reset-password', { token, newPassword }),
  checkEmail: (email: string) => publicApiClient.get<{ data: { isPartner: boolean } }>(`/api/partner/auth/check-email?email=${encodeURIComponent(email)}`),
  myProjects: () => publicApiClient.get<{ data: PartnerProject[] }>('/api/partner/projects'),
  projectDocuments: (projectId: number) => publicApiClient.get<{ data: PartnerDocument[] }>(`/api/partner/projects/${projectId}/documents`),
  uploadProjectDocument: (projectId: number, input: { fileDataUri: string; originalFilename: string; documentType: string }) =>
    publicApiClient.post<{ data: { id: number } }>(`/api/partner/projects/${projectId}/documents`, input),
  downloadUrl: (documentId: number) => `/api/partner/documents/${documentId}/download`,
};
